"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultDateTimeLabelFormats = {
    millisecond: '%H:%M:%S.%L',
    second: '%H:%M:%S',
    minute: '%H:%M',
    hour: '%H:%M',
    day: '%b %e',
    week: '%b %e',
    month: "%b '%y",
    year: '%Y'
};
exports.default = defaultDateTimeLabelFormats;
//# sourceMappingURL=defaultDateTimeLabelFormats.js.map